import { BehaviorSubject, Observable, Subject, Subscriber } from 'rxjs';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { map, merge } from 'rxjs/operators';
import { TeardownLogic } from 'rxjs/Subscription';

export enum WebSocketReadyState {
	CONNECTING = 0,
	OPEN = 1,
	CLOSING = 2,
	CLOSED = 3
}

export function WebSocketReadyStateToString(state: WebSocketReadyState): string {
	switch (state) {
		case WebSocketReadyState.CONNECTING:
			return 'CONNECTING';
		case WebSocketReadyState.OPEN:
			return 'OPEN';
		case WebSocketReadyState.CLOSING:
			return 'CLOSING';
		case WebSocketReadyState.CLOSED:
			// console.log('WebSocketReadyState CLOSED!')
			return 'CLOSED';
		default:
			return '[invalid]';
	}
}

export class WebSocketObservable<D, U = D> extends Observable<D> {

	private readonly ws: WebSocket;
	private readonly onmessage: Observable<MessageEvent>;
	private readonly onerror: Observable<Event>;
	private readonly manualStatusUpdates: BehaviorSubject<WebSocketReadyState>;

	public readonly status: Observable<WebSocketReadyState>;

	constructor(
		private updater: Observable<U>,
		uri: string,
		protocols?: string|string[]
	) {
		super();

		// Per prima cosa genero il socket
		this.ws = new WebSocket(uri, protocols);

		const source = new Subject<D>();
		this.source = source;
		this.onmessage = fromEvent<MessageEvent>(this.ws, 'message');
		this.onerror = fromEvent<Event>(this.ws, 'error');
		this.manualStatusUpdates = new BehaviorSubject<WebSocketReadyState>(WebSocketReadyState.CONNECTING);

		// Ora mi aggancio agli eventi
		this.status = fromEvent(this.ws, 'close').pipe(
			merge(fromEvent(this.ws, 'open')),
			map(() => this.ws.readyState as WebSocketReadyState),
			merge(this.manualStatusUpdates)
		);
	}

	public _subscribe(subscriber: Subscriber<any>): TeardownLogic {
		const source = this.source as Subject<D>;

		// Ora i dati
		const eventSubscription = this.onmessage
			.subscribe(e => source.next(JSON.parse(e.data) as D));

		const errSubscription = this.onerror
			.subscribe(e => {
				console.error('onerror', e)
				source.error(e)
			});

		const updateSubsription = this.updater.subscribe((next: U) => {
			if (this.ws.readyState === WebSocketReadyState.OPEN) {
				this.ws.send(JSON.stringify(next));
			} // FIXME: else error?
		});

		const base = source.subscribe(subscriber);

		return () => {
			this.manualStatusUpdates.next(WebSocketReadyState.CLOSING);
			eventSubscription.unsubscribe();
			updateSubsription.unsubscribe();
			errSubscription.unsubscribe();
			source.complete();
			this.ws.close();
			return base.unsubscribe();
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/angular-rest/WebSocket.ts